import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_20px_50px_-20px_rgba(139,111,191,0.25)] rounded-3xl p-8 sm:p-14 text-center relative overflow-hidden" data-id="element-213">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[60px] pointer-events-none" data-id="element-214"></div>

          <div className="inline-flex items-center gap-2 bg-cta-green/10 text-cta-green border border-cta-green/25 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wider mb-6 relative z-10" data-id="element-215">
            <ShieldCheck className="w-4 h-4" data-id="element-216" />
            Garanzia totale 7 giorni
          </div>

          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight relative z-10" data-id="element-217">
            Se non fa per te, ti rimborsiamo al{' '}
            <span className="text-cta-green" data-id="element-218">100%</span>.
          </h2>

          <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto relative z-10 mb-6" data-id="element-219">
            Apri i 6 volumi. Controlla i 6 bonus. Usali nella tua prossima
            lezione se vuoi. Se entro{' '}
            <span className="text-text-main font-bold" data-id="element-220">7 giorni</span> non è
            quello che cercavi, ti restituiamo ogni centesimo.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 max-w-2xl mx-auto mb-6 relative z-10" data-id="element-221">
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-222">
              <p className="text-text-main font-black text-sm" data-id="element-223">
                Nessuna domanda
              </p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-224">
                Non ti chiediamo spiegazioni
              </p>
            </div>
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-225">
              <p className="text-text-main font-black text-sm" data-id="element-226">Nessun modulo</p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-227">
                Basta un'email e basta
              </p>
            </div>
            <div className="bg-bg-main/60 border border-border-light rounded-xl px-4 py-3" data-id="element-228">
              <p className="text-text-main font-black text-sm" data-id="element-229">Nessun dramma</p>
              <p className="text-text-sec text-xs mt-0.5" data-id="element-230">Rimborso in 48h</p>
            </div>
          </div>

          <p className="text-text-sec text-xs sm:text-sm font-medium relative z-10" data-id="element-231">
            Oltre{' '}
            <span className="text-text-main font-bold" data-id="element-232">15.000 istruttrici</span>{' '}
            lo usano già. Il nostro tasso di rimborso è inferiore all'1%.
          </p>
        </div>
      </div>
    </section>;
}